// OptionWrapper.jsx
import { useMemo } from "react";

const GOOGLE_COLORS = {
  red: { border: "#EA4335", bg: "#fff8f8", notchBg: "#EA4335" },
  blue: { border: "#4285F4", bg: "#f5f8ff", notchBg: "#4285F4" },
  green: { border: "#34A853", bg: "#f5fff8", notchBg: "#34A853" },
  yellow: { border: "#FBBC05", bg: "#fffdf0", notchBg: "#FBBC05" },
};

const COLOR_KEYS = Object.keys(GOOGLE_COLORS);

function pickColor(label) {
  let hash = 0;
  for (let i = 0; i < label.length; i++) hash = label.charCodeAt(i) + ((hash << 5) - hash);
  return COLOR_KEYS[Math.abs(hash) % COLOR_KEYS.length];
}

export default function OptionWrapper({
  label = "Option",
  children,
  isSelected = false,
  onSelect = () => { },
}) {
  const colorKey = useMemo(() => pickColor(label), [label]);
  const { border, bg, notchBg } = GOOGLE_COLORS[colorKey];

  return (
    <div style={{
      position: "relative",
      width: "100%",
      boxSizing: "border-box",
      marginTop: 28,          // ← Fix 1: space for notch above
    }}>

      {/* Notch tab */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 14,
        transform: "translateY(-100%)",
        background: isSelected ? notchBg : "#b0b0b0",
        color: "#fff",
        fontSize: 11,
        fontWeight: 700,
        fontFamily: "'Nunito', sans-serif",
        letterSpacing: "0.04em",
        padding: "3px 12px 4px 12px",
        borderRadius: "6px 6px 0 0",
        userSelect: "none",
        whiteSpace: "nowrap",
        zIndex: 2,
        cursor: "pointer",
      }}
        onClick={onSelect}
      >
        {label}
      </div>

      {/* Main box */}
      <div
        onClick={onSelect}
        style={{
          width: "100%",
          boxSizing: "border-box",
          borderRadius: 10,
          overflow: "visible",
          position: "relative",
          zIndex: 1,
          cursor: "pointer",
          transition: "border-width 0.1s, background 0.1s",
          // subtle shadow when selected
          border: `${isSelected ? 2 : 1.5}px solid ${isSelected ? border : "#d0d0d0"}`,
          background: isSelected ? bg : "#ffffff",
          boxShadow: isSelected
            ? `0 0 0 3px ${border}22`
            : "0 1px 4px rgba(0,0,0,0.06)",
        }}
      >
        {children}
      </div>
    </div>
  );
}